/**
 * 接口地址的统一管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API
}
export default {

  //消息推送配置
  pushMsgConfig: {
    query:`${base.url}/crs/pushmsgconfig/list`,
    save: `${base.url}/crs/pushmsgconfig/save`,
    edit: `${base.url}/crs/pushmsgconfig/edit`,
    del: `${base.url}/crs/pushmsgconfig/del`,
  },
  pushMsgLog: {
    uploadTemplate:`${base.url}/crs/msgpushlog/uploadTemplate`,
    save:`${base.url}/crs/msgpushlog/save`,
    query:`${base.url}/crs/msgpushlog/list`,
    getEnv:`${base.url}/crs/msgpushlog/getEnv`,
    setEnv:`${base.url}/crs/msgpushlog/setEnv`,
    upload:`${base.url}/cloud/file/uploadImage`,
  },
  pushMsg: {
    uploadTemplate:`${base.url}/crs/pushMsg/uploadTemplate`,
    query:`${base.url}/crs/pushMsg/list`,
    save: `${base.url}/crs/pushMsg/save`,
    edit: `${base.url}/crs/pushMsg/edit`,
    del: `${base.url}/crs/pushMsg/del`,
    status: `${base.url}/crs/pushMsg/status`,
    getData: `${base.url}/crs/pushMsg/getData`,
    push: `${base.url}/crs/pushMsg/push`,
    startOrStop: `${base.url}/crs/pushMsg/startOrStop`,
    editMongoMsg: `${base.url}/crs/pushMsg/editMongoMsg`,
    deletMongoMsg: `${base.url}/crs/pushMsg/deletMongoMsg`,
  },
  templateMsg: {
    query:`${base.url}/crs/templateMsg/list`,
    save: `${base.url}/crs/templateMsg/save`,
    edit: `${base.url}/crs/templateMsg/edit`,
    del: `${base.url}/crs/templateMsg/del`,
    status: `${base.url}/crs/templateMsg/status`,
    getData: `${base.url}/crs/templateMsg/getData`,
  },
  templateRecord: {
    query:`${base.url}/crs/templateMsgRecord/list`,
  },
  active:{
    channel:{
      query:`${base.url}/crs/activechannel/list`,
      queryAll:`${base.url}/crs/activechannel/listAll`,
      save:`${base.url}/crs/activechannel/save`,
      edit:`${base.url}/crs/activechannel/edit`,
      del:`${base.url}/crs/activechannel/del`,
    },
    active:{
      query:`${base.url}/crs/active/list`,
      save:`${base.url}/crs/active/save`,
      edit:`${base.url}/crs/active/edit`,
      editStatus:`${base.url}/crs/active/editStatus`,
    },
    user:{
      qurey:`${base.url}/crs/activeuser/list`,
      edit:`${base.url}/crs/activeuser/edit`,
      export:`${base.url}/crs/activeuser/export`,
    },
    black:{
      qurey:`${base.url}/crs/activeblacklist/list`,
    },
    bonus:{
      qurey:`${base.url}/crs/activeuserbonus/list`,
      export:`${base.url}/crs/activeuserbonus/export`,
    }
  },
  luckyDraw:{
    base:`${base.url}/crs`,
    event:{
      page:`${base.url}/crs/activity/luckyDraw/page`,
      getProduction:`${base.url}/crs/activity/luckyDraw/getProduction`,
      id:`${base.url}/crs/activity/luckyDraw/`,
      save:`${base.url}/crs/activity/luckyDraw/save`,
      updateStatus:`${base.url}/crs/activity/luckyDraw/updateStatus`,
      delete:`${base.url}/crs/activity/luckyDraw`,
      conditionGroupDelete:`${base.url}/crs/activity/luckyDraw/conditionGroupDelete`,
      conditionDelete:`${base.url}/crs/activity/luckyDraw/conditionDelete`,
      prizeDelete:`${base.url}/crs/activity/luckyDraw/prizeDelete`,
      specialDelete:`${base.url}/crs/activity/luckyDraw/specialDelete`,
      import:`${base.url}/crs/activity/luckyDraw/importBlack`
    },
    black:{
      page:`${base.url}/crs/activity/luckyDrawBlack/page`,
      delete:`${base.url}/crs/activity/luckyDrawBlack`
    },
    record:{
      page:`${base.url}/crs/activity/luckyDrawReCord/page`,
      getRecordPrize:`${base.url}/crs/activity/luckyDrawReCord/getRecordPrize`,
      export:`${base.url}/crs/activity/luckyDrawReCord/export1`
    },
    user:{
      page:`${base.url}/crs/activity/luckyDrawUser/page`,
      getLuckyDrawInfo:`${base.url}/crs/activity/luckyDrawUser/getLuckyDrawInfo`,
      export:`${base.url}/crs/activity/luckyDrawUser/export`,
      getLuckyDrawStatistics:`${base.url}/crs/activity/luckyDrawUser/getLuckyDrawStatistics`
    }
  },
  clockIn:{
    base:`${base.url}/crs`,
    event:{
      page:`${base.url}/crs/activity/clockIn/page`,
      id:`${base.url}/crs/activity/clockIn/`,
      save:`${base.url}/crs/activity/clockIn/save`,
      updateStatus:`${base.url}/crs/activity/clockIn/updateStatus`,
      delete:`${base.url}/crs/activity/clockIn`
    },
    record:{
      page:`${base.url}/crs/activity/clockInReCord/page`,
      export:`${base.url}/crs/activity/clockInReCord/export1`
    },
    user:{
      page:`${base.url}/crs/activity/clockInUser/page`,
      getClockInInfo:`${base.url}/crs/activity/clockInUser/getClockInInfo`,
      export:`${base.url}/crs/activity/clockInUser/export`
    }
  },
  gameRank:{
    base:`${base.url}/crs`,
    event:{
      page:`${base.url}/crs/activity/gameRank/page`,
      getProduction:`${base.url}/crs/activity/gameRank/getProduction`,
      id:`${base.url}/crs/activity/gameRank/`,
      save:`${base.url}/crs/activity/gameRank/save`,
      updateStatus:`${base.url}/crs/activity/gameRank/updateStatus`,
      delete:`${base.url}/crs/activity/gameRank`,
      conditionGroupDelete:`${base.url}/crs/activity/gameRank/conditionGroupDelete`,
      conditionDelete:`${base.url}/crs/activity/gameRank/conditionDelete`,
      prizeDelete:`${base.url}/crs/activity/gameRank/prizeDelete`,
      specialDelete:`${base.url}/crs/activity/gameRank/specialDelete`,
      import:`${base.url}/crs/activity/gameRank/importBlack`
    },
    black:{
      page:`${base.url}/crs/activity/gameRankBlack/page`,
      delete:`${base.url}/crs/activity/gameRankBlack`
    },
    record:{
      page:`${base.url}/crs/activity/gameRankReCord/page`,
      getRecordPrize:`${base.url}/crs/activity/gameRankReCord/getRecordPrize`,
      export:`${base.url}/crs/activity/gameRankReCord/export1`
    },
    user:{
      page:`${base.url}/crs/activity/gameRankUser/page`,
      getGameRankInfo:`${base.url}/crs/activity/gameRankUser/getGameRankInfo`,
      export:`${base.url}/crs/activity/gameRankUser/export`,
      getGameRankStatistics:`${base.url}/crs/activity/gameRankUser/getGameRankStatistics`
    }
  },

  utils: {
    uploadFile: `${base.url}/crs/util/uploadTemplate`
  },

  quantityTask: {
    balanceQuery: `${base.url}/crs/task/balance/list`,
    balanceExport: `${base.url}/crs/task/balance/export`,

    detailQuery: `${base.url}/crs/task/quality/list`,
    quantityDetailExport: `${base.url}/crs/task/quality/export`,

    dailyQuery: `${base.url}/crs/task/daily/list`,
    dailyEdit: `${base.url}/crs/task/daily/edit`,
    dailyDel: `${base.url}/crs/task/daily/del`,
    dailyStatus: `${base.url}/crs/task/daily/status`,
    dailyTaskCategory: `${base.url}/crs/task/category/tasks`,

    proposalQuery: `${base.url}/crs/task/proposal/list`,
    proposalEdit: `${base.url}/crs/task/proposal/edit`,
    proposalStatus: `${base.url}/crs/task/proposal/status`,
    proposalDel: `${base.url}/crs/task/proposal/del`,

    exProposalQuery: `${base.url}/crs/task/exproposal/list`,
    exProposalStatus: `${base.url}/crs/task/exproposal/status`,

    configGet: `${base.url}/crs/task/config/get`,
    configEdit: `${base.url}/crs/task/config/edit`,
    configDel: `${base.url}/crs/task/config/del`,

    addtionalConfig: `${base.url}/crs/task/addtional/config`,
    addtionalEdit: `${base.url}/crs/task/addtional/edit`,

    specialList: `${base.url}/crs/task/special/list`,
    specialUpload: `${base.url}/crs/task/special/upload`,
    specialDel: `${base.url}/crs/task/special/del`,

    jpushMsgInfo: `${base.url}/crs/task/jpush/list`,
    tradeList: `${base.url}/crs/task/trade/list`,
    limitTask: `${base.url}/crs/task/limit_task`,

    activity: {
      edit: `${base.url}/crs/activity/edit`,
      del: `${base.url}/crs/activity/del`,
      status: `${base.url}/crs/activity/status`,
      list: `${base.url}/crs/activity/list`,
      dicesDetail: `${base.url}/crs/activity/dicesDetails`,
      dicesBalance: `${base.url}/crs/activity/dicesBalance`,
    },
  }
}


